// React
import React, { useEffect, useState } from "react";
import Select from "react-select";

// Reactstrap
import { Col, Button, Modal, ModalHeader, Label, Input } from "reactstrap";

// Formik & Yup
import { useFormik } from "formik";
import * as Yup from "yup";

export const ModalInputUnits = (props) => {
  const [selectOrganization, setSelectOrganization] = useState({
    value: "null",
    label: "Selecione uma organização",
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      typeInput: props.selectUnit
        ? {
            value: props.selectUnit.id_organization,
            label: props.selectUnit.name_organization,
          }
        : null,
      nameInput: props.selectUnit ? props.selectUnit.name : "",
    },
    validationSchema: Yup.object({
      typeInput: Yup.object().nullable().required("Selecione uma organização"),
      nameInput: Yup.string().required("Nome é obrigatório"),
    }),

    onSubmit: (values) => {
      props.handleSubmit({
        value: selectOrganization.value,
        name: values.nameInput,
      });
      setSelectOrganization({
        value: null,
        label: "Selecione uma organização",
      });
      validation.resetForm();
    },
  });

  const createData = () => {
    let data = props.data;
    let newData = data.map((typeNotes) => {
      return {
        value: typeNotes.id,
        label: typeNotes.name,
      };
    });

    return newData;
  };

  const findOrganization = (name) => {
    const organization = props.data.find(
      (organizationItem) => organizationItem.name === name
    );

    if (organization) {
      setSelectOrganization({
        label: organization.name,
        value: organization.id,
      });
    }
  };

  useEffect(() => {
    if (props.selectUnit) {
      findOrganization(props.selectUnit.name_organization);
    }
  }, [props.selectUnit]);

  return (
    <Modal
      id="fadeInleftModal"
      isOpen={props.isOpen}
      toggle={() => {
        props.toogle();
      }}
      modalClassName="fadeInLeft"
      centered
      autoFocus={false}
    >
      <ModalHeader>{props.title}</ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
          }}
        >
          <div className="mb-3">
            <label htmlFor="typeInput" className="col-form-label">
              Organização
            </label>
            <Col md={12}>
              <div className="mb-3">
                <Select
                  isClearable={true}
                  value={selectOrganization}
                  onChange={(e) => {
                    const event = {
                      target: {
                        name: "typeInput",
                        value: e,
                      },
                    };
                    setSelectOrganization(e);
                    validation.handleChange(event);
                  }}
                  onBlur={validation.handleBlur}
                  options={createData() || []}
                  id="typeInput"
                  inputId="typeInput"
                />
                {validation.touched.typeInput && validation.errors.typeInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.typeInput}
                  </p>
                ) : null}
              </div>
            </Col>
            <Col md={12}>
              <div className="mb-3">
                <Label htmlFor="nameInput" className="form-label">
                  Nome
                </Label>
                <Input
                  type="text"
                  className="form-control"
                  id="nameInput"
                  rows="3"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.nameInput || ""}
                ></Input>
                {validation.touched.nameInput && validation.errors.nameInput ? (
                  <p className="labelErrorValidation">
                    {validation.errors.nameInput}
                  </p>
                ) : null}
              </div>
            </Col>
          </div>
          <div className="modal-footer">
            <Button
              color="light"
              onClick={() => {
                setSelectOrganization({
                  value: null,
                  label: "Selecione uma organização",
                });
                props.toogle();
              }}
            >
              {" "}
              Cancelar{" "}
            </Button>
            <Button color="primary" type="submit">
              {" "}
              Salvar{" "}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
